import React from 'react';
import { InplaceField } from '@aha-app/react-in-place';
import SelectroV2InPlaceTagsTriggerTemplate from '../../../SelectroV2/Templates/SelectroV2TagsTriggerTemplate/SelectroV2InPlaceTagsTriggerTemplate';

const SelectableAttribute = ({ className, ...props }) => {
  return (
    <InplaceField
      {...props}
      class={className}
      style={{ flexWrap: 'wrap' }}
      tabIndex='1'
      type='selectro'
      selectroType='multiple'
      includeDataInSelectedItems
      disabled={!props.editable}
      templates={internalProps => {
        return {
          ...props.templates,
          trigger: ({ items }) => {
            return (
              <SelectroV2InPlaceTagsTriggerTemplate
                callSelectCallbackOnRemove
                noneSelected={props.text.noneSelected}
                items={items}
                editable={internalProps.editable}
                class={internalProps.class}
                showInput={internalProps.showInput}
                focusing={internalProps.focusing}
              />
            );
          },
        };
      }}
    />
  );
};

export default SelectableAttribute;
